module.exports = __webpack_public_path__ + "static/media/express.dd74a1d5.jpg";